import { Result, backendApi } from "./backendApi";

export interface DataProviderModel {
  id: number;
  name?: string;
}

class GetDataProvidersRequest {}

class GetDataProvidersResponse {
  dataProviders?: DataProviderModel[];
}

export const dataProviderApi = {
  async getDataProviders(): Promise<Result<DataProviderModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetDataProvidersResponse>(
        "GetDataProviders",
        new GetDataProvidersRequest(),
      );

    if (response.ok) {
      return { ok: true, value: response.value.dataProviders ?? [] };
    }

    return response;
  },
};
